import { convertEntityUri } from "./convertEntityUri"
import { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"

interface Button {
  name: string
  url: string
}

export interface ImageFormatted {
  start?: boolean | undefined
  src: string
  alt: string
  width: number | "auto"
  height: number | "auto"
  isLottie?: boolean
}

export const getButton = (btnObj: Button) => {
  if (btnObj?.url) {
    return {
      label: btnObj.name ? btnObj.name : "",
      href: btnObj.url ? convertEntityUri(btnObj.url) : "/",
    }
  } else {
    return {
      label: btnObj?.name ? btnObj.name : "",
    }
  }
}

export const getLink = (linkObj: { name?: string; url: string }) => {
  return {
    text: linkObj?.name ? linkObj.name : "",
    href: convertEntityUri(linkObj?.url || ""),
  }
}

export const getVideo = (vidObj: { uri: string }) => {
  return convertEntityUri(vidObj.uri)
}

export const getImage = (imgObj: {
  url: any
  src: string
  altText: string
  width: number | "auto"
  height: number | "auto"
  objectFit?: string
  start?: boolean
}) => {
  if (imgObj?.url)
    return {
      src: `${getUmbracoMediaUrl(decodeURIComponent(imgObj?.url))}`,
      alt: imgObj?.altText ? imgObj.altText : "image-alt",
      width: imgObj.width || "auto",
      height: imgObj.height || "auto",
      ...(imgObj.start != null && { start: imgObj.start }),
    }
}

export const getFile = (fileObj: { url: any; filename?: string }) => {
  if (fileObj?.url)
    return {
      filename: fileObj?.filename ? fileObj.filename : "",
      src: `${decodeURIComponent(fileObj?.url)}`,
    }
}
